import { TuiButton } from "@taiga-ui/core";
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '@src/app/shared';

import { CounterComponent } from './counter.component';

@NgModule({
  declarations: [CounterComponent],
  imports: [CommonModule, ReactiveFormsModule, SharedModule, TuiButton],
  exports: [CounterComponent],
})
export class CounterModule {}
